module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-256.f96a687c.jpg";